/**
 * 불러톡 상담 팝업 (/adm/chat — adm/pages/chat) — 화면 본체는 공유 하네스 $j.F.Chat (값은 blade #chat-data).
 */
export default class ChatPopup {
    initialize() {
        $j.F.Chat.init();
    }
}
